// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formulate-input-errors[data-v-1a775bfe]{color:red}.no-room-header[data-v-1a775bfe]{text-align:center}.chat-list-item[data-v-1a775bfe]{min-height:50px}.chat-list-item.selected[data-v-1a775bfe]{background:#e1f5fe}.v-progress-circular[data-v-1a775bfe]{position:absolute;right:12px;bottom:64px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
